import { render, staticRenderFns } from "./LateralFilters.vue?vue&type=template&id=567ddcb8&scoped=true&"
import script from "./LateralFilters.vue?vue&type=script&lang=js&"
export * from "./LateralFilters.vue?vue&type=script&lang=js&"
import style0 from "./LateralFilters.vue?vue&type=style&index=0&id=567ddcb8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567ddcb8",
  null
  
)

export default component.exports